import { SaveButton } from '@core/components/Buttons';
import { DateInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import { Fade, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import { compraFormaPagamentoStyles } from './styles';

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const CompraPagamentoParcelado = ({
  id,
  name,
  onChange,
  onBlur,
  values,
  errors,
  touched,
  onGerarParcelas,
  onChangeDataPrimeiraParcela,
  submitCount,
  minDate,
  disabled,
  compraPaga,
  valorTotal,
}) => {
  const styles = compraFormaPagamentoStyles();

  const _errors = {
    quantidade: (submitCount > 0 || touched?.quantidade) && errors?.quantidade,
    parcelas: errors?.parcelas?.map((err, index) => {
      const touch = touched?.parcelas?.length >= index && touched?.parcelas?.[index];
      const error = errors?.parcelas?.length >= index && errors?.parcelas?.[index];

      return {
        dataVencimento: (submitCount > 0 || touch?.dataVencimento) && error?.dataVencimento,
        valorParcela: (submitCount > 0 || touch?.valorParcela) && error?.valorParcela,
      };
    }),
    diferencaParcelas: errors?.diferencaParcelas,
  };

  const handleChangeDataVencimento = (e, index) => {
    onChange(e);
    if (index === 0) {
      onChangeDataPrimeiraParcela(moment(e.target.value, 'DD/MM/YYYY'));
    }
  };

  return (
    <>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <CurrencyTextField
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="999"
          minimumValue="0"
          decimalPlaces={0}
          error={!!_errors?.quantidade}
          helperText={_errors?.quantidade}
          currencySymbol=""
          onChange={(e, value) => {
            onChange({
              target: {
                id: `${id}.quantidade`,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          onBlur={onBlur}
          id={`${id}.quantidade`}
          name={`${id}.quantidade`}
          value={values?.quantidade}
          fullWidth
          variant="outlined"
          label="Quantidade de parcelas"
          disabled={disabled || compraPaga}
        />
      </Grid>
      <Grid item xs={1} sm={1} md={1} lg={1} xl={1} style={{ display: 'flex', alignItems: 'center' }}>
        <SaveButton id="gerar-parcelas" type="button" onClick={onGerarParcelas} disabled={compraPaga}>
          Gerar
        </SaveButton>
      </Grid>
      <Grid item xs={3} />
      <Fade timeout={400} in={values?.parcelas?.length > 0} style={{ width: '100%' }}>
        <Grid container spacing={3} style={{ marginLeft: 0 }} className="mt-4">
          {values?.parcelas?.map((parcela, index) => (
            <>
              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                lg={1}
                xl={1}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                {`Parcela ${index + 1}`}
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                <DateInput
                  id={`${id}.parcelas[${index}].dataVencimento`}
                  name={`${name}.parcelas[${index}].dataVencimento`}
                  onChange={(e) => handleChangeDataVencimento(e, index)}
                  onBlur={onBlur}
                  value={values?.parcelas?.[index]?.dataVencimento || null}
                  error={!!_errors?.parcelas?.[index]?.dataVencimento}
                  helperText={_errors?.parcelas?.[index]?.dataVencimento}
                  touched={touched?.parcelas?.[index]?.dataVencimento}
                  required
                  fullWidth
                  variant="outlined"
                  label="Data do vencimento"
                  minDate={minDate}
                  disabled={compraPaga}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                <CurrencyTextField
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  maximumValue="999999999"
                  minimumValue="0"
                  decimalPlaces={2}
                  decimalPlacesShownOnBlur={2}
                  decimalPlacesShownOnFocus={2}
                  error={!!_errors?.parcelas?.[index]?.valorParcela}
                  helperText={_errors?.parcelas?.[index]?.valorParcela}
                  onChange={(e, value) => {
                    onChange({
                      target: {
                        id: e.target.id,
                        value: e.target.value === '' ? '' : value,
                      },
                    });
                  }}
                  onBlur={onBlur}
                  id={`${id}.parcelas[${index}].valorParcela`}
                  name={`${name}.parcelas[${index}].valorParcela`}
                  value={values?.parcelas?.[index]?.valorParcela}
                  fullWidth
                  variant="outlined"
                  label="Valor parcelado (R$) *"
                  disabled={compraPaga}
                  hideCurrencySymbol
                />
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3} />
            </>
          ))}
        </Grid>
      </Fade>
      {!!values?.parcelas?.length && values?.diferencaParcelas > 0 && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className={clsx(styles.diferencaParcelas, _errors.diferencaParcelas ? 'erro' : '')}>
            Diferença: {getCurrency(values?.diferencaParcelas)}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default CompraPagamentoParcelado;
